module.exports = __webpack_public_path__ + "static/media/pink-truck.81edd552.svg";